import { Directive, DirectiveBinding } from 'vue'

// 限制输入整数
export const integer:Directive = {
    mounted(el, binding) {
        el.addEventListener('input', function (e) {
            let val = e.target.value
            let newVal = val.replace(/[^\d]/g, '')
            e.target.value = newVal
        })
    }
};

// 限制输入两位小数
export const decimal:Directive = {
    mounted(el, binding) {
        el.addEventListener('input', function (e) {
            let val = e.target.value
            let newVal = val.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
            if (newVal.split('.').length > 1) {
                newVal = newVal.split('.')[0] + '.' + newVal.split('.')[1].slice(0, 2);
            }
            e.target.value = newVal
        })
    }
};

// 限制输入中英文和数字
export const nonSpecialChar:Directive = {
    mounted(el, binding) {
        el.addEventListener('input', function (e) {
            let val = e.target.value
            let newVal = val.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, '')
            e.target.value = newVal
        })
    }
}

// 限制输入十六进制颜色值，限制 6 位
export const hexColor:Directive = {
    mounted(el, binding) {
        el.addEventListener('input', function (e) {
            let val = e.target.value
            let newVal = val.replace(/[^0-9a-fA-F]/g, '')
            if (newVal.length > 6) {
                newVal = newVal.slice(0, 6)
            }
            e.target.value = newVal
        })
    }
}